<template>
  <div class="hideBox">
    <!--   关注   -->
    <focus v-if="type==4||type==6||type==3" :item="item" :type="type" @end="(v)=>{$emit('end',v)}" @changeStatus="v=>$emit('changeStatus',v)"></focus>
    <!--   交流   -->
    <mail :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></mail>
    <!--   函询   -->
    <im :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></im>
    <!--   立即报名   -->
    <signUp v-if="type==4" :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></signUp>
    <!--   报名   -->
    <sign v-if="type==6" :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></sign>
    <!--   邀请   -->
    <invitation v-if="type==5" :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></invitation>
    <!--   加盟   -->
    <jJoin v-if="type==5" :item="item" :type="type" @changeStatus="v=>$emit('changeStatus',v)"></jJoin>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "hideBox",
  components: {
    focus: () => import('./button/focus'),//关注
    mail: () => import('./button/mail'),//函询
    im: () => import('./button/im'),//交流
    signUp: () => import('./button/signUp'),//立即报名
    sign: () => import('./button/sign'),//报名
    invitation: () => import('./button/invitation'),//邀请
    jJoin: () => import('./button/jJoin'),//加盟
  },
  props: {
    item: {
      type: Object
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  data() {
    return {}
  },
  filters: {},
  watch: {},
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo,
      teamNo: state => state.user.teamNo,
    })
  },
  methods: {},
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.hideBox{
  display: flex;
  justify-content: center;
  padding: 20px;
  /deep/.btnitem{
    width: 82px;
    height: 34px;
    box-sizing: border-box;
    border: 1px solid #B79255;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #B79255;
    margin-right: 15px;
    justify-content: center;
    border-radius: 4px;
    &:hover{
      border-color: #B79255;
      color: #B79255;
    }
    img{
      margin-right: 5px;
      margin-top: 2px;
    }
  }
}
</style>
